import { SparkleIcon } from "./SparkleIcon";

interface StatusMessageProps {
  message?: string | null;
  primaryColor: string;
}

export function StatusMessage({ message, primaryColor }: StatusMessageProps) {
  return (
    <div
      data-testid="status-indicator"
      className="inline-flex items-center gap-2 rounded-lg bg-[#f8f9fa] pr-3 py-2"
    >
      <SparkleIcon primaryColor={primaryColor} />
      <span className="streaming-text text-base italic">{message}</span>
    </div>
  );
}
